// 🔄 Indicador circular responsivo
import React from "react";

type CircularProgressProps = {
  percentage: number; // 0 – 100
  strokeWidth?: number; // Grosor del anillo
  color?: string; // Color de la parte "llena"
  trackColor?: string; // Color de la parte "vacía"
  className?: string; // Para estilos adicionales
};

const CircularProgress: React.FC<CircularProgressProps> = ({
  percentage,
  strokeWidth = 8,
  color = "#b90029",
  trackColor = "#e5e7eb",
  className = "",
}) => {
  // Usar viewBox para hacer el SVG escalable
  const viewBoxSize = 100;
  const radius = (viewBoxSize - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className={`circular-progress-container ${className}`}>
      <svg
        viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
        className="circular-progress-svg"
        role="img"
        aria-label={`Progreso: ${percentage}%`}
      >
        {/* Anillo base (gris) */}
        <circle
          cx={viewBoxSize / 2}
          cy={viewBoxSize / 2}
          r={radius}
          stroke={trackColor}
          strokeWidth={strokeWidth}
          fill="transparent"
        />

        {/* Anillo de progreso */}
        <circle
          cx={viewBoxSize / 2}
          cy={viewBoxSize / 2}
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeLinecap="round"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${viewBoxSize / 2} ${viewBoxSize / 2})`}
          style={{
            transition: "stroke-dashoffset 0.5s ease-in-out",
          }}
        />

        {/* Texto con el % */}
        <text
          x="50%"
          y="50%"
          dominantBaseline="central"
          textAnchor="middle"
          fontSize="16" // Tamaño fijo en el viewBox
          fontWeight="700"
          fill="#374151"
        >
          {percentage}%
        </text>
      </svg>
    </div>
  );
};

export default CircularProgress;
